import { useCallback } from 'react';
import { useBrandsOperations } from 'entities/brands';
import { useFavouriteStations } from 'entities/stations';
import { useGetStationsByBrandCode } from 'store/features/stations/selectors/allStations';
import {
  useOperations,
  useStations,
  useAllStations
} from 'store/features/stations';

import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';

import { STATIONS_AMPLITUDE_EVENTS } from 'entities/stations';
import { EMPTY_ARRAY } from 'common/constants';

import { IStation } from 'dataSources/Typicode/stations/types/station';

export const useDeleteFavouriteBrand = () => {
  const getStationsByBrandCode = useGetStationsByBrandCode();
  const { updateStations, updateAllStations } = useOperations();
  const stations = useStations() || EMPTY_ARRAY;
  const allStations = useAllStations() || EMPTY_ARRAY;
  const favouriteStations = useFavouriteStations() || EMPTY_ARRAY;
  const {
    deleteFavouriteBrands,
    getFavouriteBrands
  } = useBrandsOperations();

  const changeStations = useCallback((brandStations?: IStation[], stations?: IStation[]) => {
    if (!brandStations || !stations) {
      return stations || EMPTY_ARRAY;
    }

    return brandStations.reduce((acc, brandStation) => {
        const index = acc.findIndex(item => item.code === brandStation.code);
        if (index !== undefined && !favouriteStations.find(favouriteStation => favouriteStation.stationCode === brandStation.code)) {
          acc[index] = { ...acc[index], favourite: false };
        }
        return acc;
    }, [...stations]);
  }, [favouriteStations]);


  const deleteFavouriteBrand = useCallback(async (billingId: string, brandCode: string) => {
    await deleteFavouriteBrands([Number(billingId)]);
    getFavouriteBrands();
    const brandStations = getStationsByBrandCode(brandCode);
    updateStations(changeStations(brandStations, stations));
    updateAllStations(changeStations(brandStations, allStations));
    logAmplitudeEvent(STATIONS_AMPLITUDE_EVENTS.deleteFavouriteBrand, { extra: { brandCode } });
  }, [
    deleteFavouriteBrands,
    getFavouriteBrands,
    getStationsByBrandCode,
    changeStations,
    updateStations,
    updateAllStations,
    allStations,
    stations
  ]);

  return deleteFavouriteBrand;
};
